import {
  error as commonError,
  finleyAssert,
} from '@finley-technologies/common';
import { CreditAgreement, typeguards } from '@finley-technologies/finley-types';

// @jendevelops could probably put this in common-frontend
export const parseBaseFields = ({
  baseFieldsJson,
  loanProductId,
  creditFacilitySlug,
  isWip,
}: {
  baseFieldsJson: string;
  creditFacilitySlug: string;
  loanProductId: string;
  isWip?: boolean;
}): CreditAgreement.DataTapeField.BaseConfig[] => {
  const baseFields = JSON.parse(baseFieldsJson);
  finleyAssert(
    typeguards.creditAgreement.isBaseFieldConfigArray(baseFields),
    new commonError.TypeError({
      resourceType: 'BaseFieldConfigArray',
      typeguardName: 'isBaseFieldConfigArray',
      metadata: {
        logMeta: {
          creditFacilitySlug,
          loanProductId,
          isWip,
        },
      },
    }),
  );
  return baseFields;
};
